import {apiRoutes} from "../routes/apiRoutes";
import { useAxiosInstance } from "../util/axiosInstance";
import useAuth from "../useAuth";
import reports from '../dummy/reports';

// Auth calls use API root (without /dashboard prefix) — they're public, no JWT needed
const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/dashboard\/?$/, '') || '';

const useApi = () => {
    const { axiosInstance } = useAxiosInstance();
    const auth = useAuth();

    const config = {};

    const downloadFile = async (url) => {
        return await axiosInstance.get(url, config);
    }

    const requestResetPassword = async (username) => {
        const response = await fetch(`${API_BASE}/auth/reset?username=${encodeURIComponent(username)}&recaptchaToken=`);
        return { data: await response.json() };
    }

    const resetPassword = async (body) => {
        const response = await fetch(`${API_BASE}/auth/reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const err = await response.json();
            throw { response: { data: err } };
        }
        return { data: await response.json() };
    }

    const getProfile = () => {
        return axiosInstance.get(apiRoutes.profile, config);
    }

    const getReports = (filter) => {
        // return axiosInstance.get(apiRoutes.reports(filter), config);
        return {
            reports: reports
        }
    }

    const getReport = (slug, filter) => {
        return axiosInstance.get(apiRoutes.report(slug, filter), config);
    }

    const getScenarios = () => {
        return axiosInstance.get(apiRoutes.scenarios, config);
    }

    const getScenario = (slug) => {
        return axiosInstance.get(apiRoutes.scenario(slug), config);
    }

    const getInteractions = (scenarioId) => {
        return axiosInstance.get(apiRoutes.interactions(scenarioId), config);
    }

    const getGoogleSettings = () => {
        return axiosInstance.get(apiRoutes.settings.google, config);
    }

    const editGoogleSettings = (body) => {
        return axiosInstance.put(apiRoutes.settings.google, body, config);
    }

    const getApiKeys = () => {
        return axiosInstance.get(apiRoutes.apiKeys, config);
    }

    const createApiKey = (body) => {
        return axiosInstance.post(apiRoutes.apiKeys, body, config);
    }

    const deleteApiKey = (keyId) => {
        return axiosInstance.delete(apiRoutes.apiKey(keyId), config);
    }

    const editApiKey = (keyId, data) => {
        return axiosInstance.put(apiRoutes.apiKey(keyId), data, config);
    }

    const getUsers = () => {
        return axiosInstance.get(apiRoutes.users, config);
    }

    const createUser = (body) => {
        return axiosInstance.post(apiRoutes.users, body, config);
    }

    const editUser = (id, data) => {
        return axiosInstance.put(apiRoutes.user(id), data, config);
    }

    const deleteUser = (id) => {
        return axiosInstance.delete(apiRoutes.user(id), config);
    }

    const getHistory = (filter) => {
        return axiosInstance.get(apiRoutes.history(filter), config);
    }

    const getVideoDetail = (requestId) => {
        return axiosInstance.get(apiRoutes.video(requestId), config);
    }

    const getTenant = async () => {
        const response = await axiosInstance.get(apiRoutes.tenant, config);
        return response.data.response;
    }

    return {
        downloadFile,
        requestResetPassword,
        resetPassword,
        getProfile,
        getReports,
        getReport,
        getScenarios,
        getScenario,
        getInteractions,
        getGoogleSettings,
        editGoogleSettings,
        getApiKeys,
        createApiKey,
        deleteApiKey,
        editApiKey,
        getUsers,
        createUser,
        editUser,
        deleteUser,
        getHistory,
        getVideoDetail,
        getTenant,
    }
}

export default useApi;
